module.exports = __webpack_public_path__ + "img/wow_audit.dc98b27e.png";